// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import { Controller } from "stimulus"
import axios from 'axios';
import Events from "../classes/Events";

const validationMapping = {
  email: value => {
    // michael.g@mitremedia.com
    // return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value))

    // michael.g+mailchimp.test.0014@mitremedia.com
    return (/^\w+([\.-]?\w+)*(\+\w+([\.-]?\w+)*)?@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value))
  },
  loginEmail: value => {
    return (/^\w+([\.\-\+]?\w+)*@\w+([\.\-]?\w+)*(\.\w{2,3})+$/.test(value))
  },
  signUpEmail: async value => {
    const { data } = await axios.post('/api/user/email_exists/', { email: value || '' })
    const { email_exists } = data;
    return !email_exists;
  },
  password: value => {
    const strongPasswordRegex = new RegExp("^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*\+\-])(?=.{8,})");
    return strongPasswordRegex.test(value)
  },
  passwordWithoutReq: value => {
    const strongPasswordRegex = new RegExp("^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*\+\-])(?=.{8,})");
    return strongPasswordRegex.test(value)
  },
  currentPassword: value => {
    const strongPasswordRegex = new RegExp("^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*\+\-])(?=.{8,})");
    return strongPasswordRegex.test(value)
  },
  firstName: value => value && value.length > 0,
  lastName: value => value && value.length > 0,
  investorType: value => value && value.length > 0,
  advisorType: value => value && value.length > 0,
  country: value => value && value.length > 0,
  cardholderName: value => value && value.length > 0,
  zipcode: value => value && value.length > 0,
  zipcodeNA: value => {
    return (/^(\d{5}(-\d{4})?|[A-Z]\d[A-Z] ?\d[A-Z]\d)$/.test(value))
  },
  creditCardNumber: value => {
    return (/^((4\d{3})|(5[1-5]\d{2})|(6011))\d{4}\d{4}\d{4}|3[4,7]\d{13}$/.test(value))
  },
  cardExpiryDate: value => {
    return (/^(0[1-9]|1[0-2])\/([2-3][0-9])$/.test(value))
  },
  cvc: value => {
    return (/^(\d{3})|(\d{4})$/.test(value))
  },
  required: value => value && value.length > 0,
  confirmPassword: (value, secondaryValue) => {
    return value == secondaryValue;
  },
  phoneNum: value => {
    return (/^[2-9]\d{2}\d{3}\d{4}$/.test(value))
  }
}

const validationMessageMapping = {
  email: 'Please enter a valid email address',
  loginEmail: 'Please enter a valid email address',
  signUpEmail: 'You already have an account, [sign in] here',
  firstName: 'Please enter your first name',
  lastName: 'Please enter your last name',
  cardholderName: "Please enter the card holder's name",
  currentPassword: 'Please enter your current password',
  password: 'Password needs to be at least 8 characters, with 1 uppercase letter, 1 special character, and 1 number',
  passwordWithoutReq: 'Password does not meet requirements',
  zipcode: 'Please enter a zipcode',
  zipcodeNA: 'Please enter a valid zipcode',
  creditCardNumber: 'Please enter a valid credit card number',
  cardExpiryDate: 'Please enter in the format MM/YY',
  cvc: 'Please enter a valid security code',
  required: 'This field is required',
  investorType: 'Please select an investor type',
  advisorType: 'Please select an advisor type',
  country: 'Please select a country',
  confirmPassword: 'Password must match',
  phoneNum: 'Please enter a phone number in the following format: 5555555555'
}

export default class extends Controller {

  submit(e) {
    e.preventDefault();
  }

  async validate(e, manualTriggerProps = {}) {
    const { target: element, callback } = manualTriggerProps;
    let target = element;
    if (e) {
      target = e.target;
    }
    const types = JSON.parse(target.dataset['types'] || '[]');

    const validationResults = await Promise.all(types.map(async type => {
      const success = await (validationMapping[type])(target.value, target.getAttribute('data-validation-secondary-value'))
      return {
        success,
        failedRule: success ? null : type
      }
    }))

    let rule = null;
    const validatedFailed = validationResults.some(({success, failedRule}) => {
      if (success) {
        return false;
      } else {
        rule = failedRule;
        return true;
      }
    })

    if (validatedFailed) {
      target.dataset['error'] = validationMessageMapping[rule];
      if (e) {
        e.stopImmediatePropagation();
      }
      if (callback) {
        callback(false);
      }
    } else {
      target.dataset['error'] = null;
      if (callback) {
        callback(true);
      }
    }
    target.dispatchEvent(Events.validationEvent);
  }
  disconnect() {
    EventManager.off('validation_triggered', this.handleValidationTriggered);
  }

  handleValidationTriggered = ({controller, target, callback}) => {
    this.validate(null, { controller, target, callback });
  }

  connect() {
    EventManager.on('validation_triggered', this.handleValidationTriggered);
  }
}
